export default {"src":"/_next/static/media/ticket_gift.2b0679c0.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};